import styled from 'styled-components';
export var EmptyValue = styled.span.withConfig({
  displayName: "EmptyValue",
  componentId: "sc-14nbx0-0"
})(["", " ", ""], function (_ref) {
  var bold = _ref.bold;
  return bold ? 'font-weight: 700;' : '';
}, function (_ref2) {
  var withLightEmpty = _ref2.withLightEmpty,
    value = _ref2.value,
    theme = _ref2.theme;
  return withLightEmpty && typeof value !== 'number' && "color: ".concat(theme.colors.fontL, ";");
});